import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Container,
  Grid,
  Typography,
  Card,
  CardContent,
  CardMedia,
} from "@mui/material";
import { useNavigate, Link } from "react-router-dom";
import axios from "axios";
import Slider from "react-slick";
import "./postcomp.css";
import loadingGif from '../../pages/CMD/loading.gif';
import parse from 'html-react-parser'; // Importing the html-react-parser library
import { ReadMore } from "@mui/icons-material";
// relativeTime.js
export function timeAgo(timestamp) {
  const now = new Date();
  const then = new Date(timestamp);
  const seconds = Math.floor((now.getTime() - then.getTime()) / 1000);

  if (seconds < 60) return `${seconds} seconds ago`;
  const minutes = Math.floor(seconds / 60);
  if (minutes < 60) return `${minutes} minutes ago`;
  const hours = Math.floor(minutes / 60);
  if (hours < 24) return `${hours} hours ago`;
  const days = Math.floor(hours / 24);
  if (days < 7) return `${days} days ago`;
  const weeks = Math.floor(days / 7);
  if (weeks < 4) return `${weeks} weeks ago`;
  const months = Math.floor(weeks / 4);
  return `${months} months ago`;}

// Function to truncate content to the first 300 words
const truncateContent = (content, maxWords) => {
  const words = content.split(" ");
  return words.length > maxWords
    ? words.slice(0, maxWords).join(" ") + "..."
    : content;
};
// relativeTime.js

const BlogSection = ({ mode }) => {
  const [loading, setLoading] = useState(true); // Added loading state
  const [blogPosts, setBlogPosts] = useState([]);
  const navigate = useNavigate();
  
  
  useEffect(() => {
    // Fetch blog posts from the API
    const fetchPosts = async () => {
      try {
        const response = await axios.get("https://sirius.runasp.net/api/Post");
        setBlogPosts(response.data);
      } catch (error) {
        console.error("Error fetching blog posts", error);
      } finally {
        setLoading(false); // Set loading to false after data is fetched or error occurs
      }
    };
    fetchPosts();
  }, []);
// relativeTime.js

  if (loading) {
    return (
      <div style={{ margin:'50px auto', textAlign:'center',  width:'200px',height:'200px' }}>
        <img width={'100%'} src={loadingGif} alt="Loading..." />
      </div>
    );
  }
  const handleNavigation = (id) => {
    navigate(`/posts/${id}`);
  };

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    appendDots: (dots) => (
      <div style={{ padding: "10px" }}>
        <ul style={{ margin: "0px", padding: "0px" }}>{dots}</ul>
      </div>
    ),
    customPaging: (i) => (
      <div
        className="custom-dot"
        style={{
          width: "10px",
          height: "10px",
          background: "lightcoral",
          borderRadius: "50%",
          display: "inline-block",
          margin: "0 5px",
        }}
      />
    ),
    arrows: true,
  };

  return (
    <Box component="section" py={6} padding={"1rem"} bgcolor="background.paper">
      <Container>
        <Grid container spacing={4} sx={{ paddingTop: "3rem" }}>
          <Grid container spacing={4}>
            {blogPosts.map((post, index) => (
              <Grid item xs={12} md={6} lg={4} key={index}>
               <Card
  style={{
    border: "1px solid",
    borderColor: mode === "dark" ? "lightcoral" : "silver",
    height: "550px", // Fixed height for the card
    display: "flex",
    flexDirection: "column",
  }}
>
  {post.photos && post.photos.length > 1 ? (
    <Slider {...settings} style={{ flex: "1 0 auto" }}>
      {post.photos.map((photo, photoIndex) => (
        <div key={photoIndex} className="custom-dot">
          <CardMedia
            component="img"
            height="200" // Adjust this to control the media height
            image={`https://sirius.runasp.net/${photo.filePath}`}
            alt={post.title}
            style={{
              borderRadius: "0 0 10px 10px",
              objectFit: "cover",
            }}
          />
        </div>
      ))}
    </Slider>
  ) : (
    post.photos && post.photos.length === 1 && (
      <CardMedia
        component="img"
        height="200" // Adjust this to control the media height
        image={`https://sirius.runasp.net/${post.photos[0].filePath}`}
        alt={post.title}
        style={{
          borderRadius: "0 0 10px 10px",
          objectFit: "cover",
        }}
      />
    )
  )}
  <CardContent
    sx={{
      flex: "1 0 auto",
      display: "flex",
      flexDirection: "column",
    }}
  >
    <Typography variant="h6" component="h3">
      <Link
        to={`/posts/${post.id}`}
        style={{ textDecoration: "none", color: "inherit" }}
      >
        {post.title}
      </Link>
    </Typography>
    <Typography variant="caption" color="textSecondary" display="block" mt={1}>
      {post.publishTime ? <p>{timeAgo(post.publishTime)}</p> : "Unknown Date"}
    </Typography>
    <Typography
      variant="body2"
      color="textSecondary"
      mt={2}
       // Handle text overflow
    >
      {parse(truncateContent(post.content, 30))}
    </Typography>
    <Box mt="auto"> {/* Pushes the button to the bottom */}
      <Button
        style={{
          color: "#fff",
          backgroundColor: "#e84545",
          marginTop: "10px", // Optional: Add margin for spacing
        }}
        onClick={() => handleNavigation(post.id)}
      >
        <ReadMore style={{margin:'2px'}}/>
        Continue reading...
      </Button>
    </Box>
  </CardContent>
</Card>


              </Grid>
            ))}
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default BlogSection;
